var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSakura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 321,
    viewBox: "0 0 321 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.501 78.8249C129.971 69.2892 144.561 53.4905 155.103 44.3843C160.951 39.3327 167.342 42.5605 169.26 50.0468C175.898 44.6562 184.495 44.7141 186.7 52.9762C191.657 71.5509 191.751 106.565 191 119.325C190 136.325 183.616 145.654 176.5 152.325C169.385 158.996 161 160.825 155.5 161.325C150 161.825 139 163.325 127.5 155.325C116 147.325 109 127.825 110.5 114.325C112 100.825 114 92.8249 123.501 78.8249Z",
    fill: "url(#paint0_radial_2508_1768)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224.064 90.9506C235.133 94.1581 254.667 103.151 266.585 110.364C273.197 114.365 272.102 121.44 265.574 125.577C272.752 130.225 275.354 138.419 268.178 143.069C252.044 153.523 218.773 164.433 206.405 167.662C189.928 171.964 179.083 168.775 170.54 164.069C161.996 159.363 157.666 151.954 155.491 146.878C153.316 141.802 148.49 131.804 152.545 118.394C156.6 104.985 172.982 92.3019 186.285 89.5568C199.587 86.8118 207.814 86.2416 224.064 90.9506Z",
    fill: "url(#paint1_radial_2508_1768)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M243.608 190.34C243.978 201.858 241.461 223.214 238.285 236.778C236.523 244.303 229.455 245.447 223.503 240.518C221.301 248.781 214.313 253.787 207.672 248.399C192.744 236.285 172.087 208.014 165.194 197.25C156.011 182.908 155.692 171.609 157.528 162.029C159.364 152.45 165.072 146.042 169.228 142.405C173.383 138.767 181.401 131.088 195.407 130.801C209.413 130.514 226.538 142.175 233.259 153.978C239.981 165.782 243.065 173.429 243.608 190.34Z",
    fill: "url(#paint2_radial_2508_1768)",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.123 239.64C144.283 243.551 123.194 247.757 109.312 248.927C101.612 249.576 98.3389 243.209 101.187 236.025C92.6485 236.484 85.7277 231.384 88.8003 223.404C95.708 205.463 116.212 177.081 124.32 167.199C135.121 154.034 145.769 150.239 155.447 149.024C165.125 147.81 172.983 151.259 177.727 154.087C182.47 156.915 192.251 162.167 196.852 175.399C201.454 188.631 195.655 208.521 186.507 218.561C177.358 228.601 171.038 233.897 155.123 239.64Z",
    fill: "url(#paint3_radial_2508_1768)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8923 170.72C73.8229 161.619 63.3058 142.862 57.9031 130.021C54.906 122.898 59.9506 117.818 67.6631 118.307C64.5877 110.328 67.2993 102.17 75.8384 102.626C95.0357 103.652 128.365 114.382 140.269 119.039C156.128 125.244 163.027 134.198 167.173 143.027C171.319 151.856 170.467 160.395 169.243 165.78C168.019 171.166 166.046 182.091 154.884 190.555C143.722 199.02 123.013 199.652 110.638 194.054C98.2619 188.455 91.2714 184.081 80.8923 170.72Z",
    fill: "url(#paint4_radial_2508_1768)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2508_1768",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-17 -92.5 98.6311 -47.6498 173 139.325)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D26378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC2C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2508_1768",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-17 -92.5 98.6311 -47.6498 173 139.325)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D26378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC2C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2508_1768",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-17 -92.5 98.6311 -47.6498 173 139.325)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D26378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC2C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2508_1768",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-17 -92.5 98.6311 -47.6498 173 139.325)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D26378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC2C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2508_1768",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-17 -92.5 98.6311 -47.6498 173 139.325)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D26378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC2C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSakura);
export default __webpack_public_path__ + "static/media/sakura.15f584d9246ea821887c2abb3caf2812.svg";
export { ForwardRef as ReactComponent };